/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Trip model module.
 * @module model/Trip
 * @version 0.0.2
 */
class Trip {
    /**
     * Constructs a new <code>Trip</code>.
     * @alias module:model/Trip
     * @param tripId {String} A unique identifier for this trip.
     * @param fromLocationId {String} The locationId for the origin location of this trip. This locationId must exist in the Locations passed in ProblemData for this problem.
     * @param toLocationId {String} The locationId for the destination location of this trip. This locationId must exist in the Locations passed in ProblemData for this problem.
     */
    constructor(tripId, fromLocationId, toLocationId) { 
        
        Trip.initialize(this, tripId, fromLocationId, toLocationId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, tripId, fromLocationId, toLocationId) { 
        obj['tripId'] = tripId;
        obj['fromLocationId'] = fromLocationId;
        obj['toLocationId'] = toLocationId;
        obj['demand'] = 1;
        obj['pickupServiceDuration'] = 0;
        obj['deliveryServiceDuration'] = 0;
    }

    /**
     * Constructs a <code>Trip</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Trip} obj Optional instance to populate.
     * @return {module:model/Trip} The populated <code>Trip</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Trip();

            if (data.hasOwnProperty('tripId')) {
                obj['tripId'] = ApiClient.convertToType(data['tripId'], 'String');
            }
            if (data.hasOwnProperty('tripName')) {
                obj['tripName'] = ApiClient.convertToType(data['tripName'], 'String');
            }
            if (data.hasOwnProperty('fromLocationId')) {
                obj['fromLocationId'] = ApiClient.convertToType(data['fromLocationId'], 'String');
            }
            if (data.hasOwnProperty('toLocationId')) {
                obj['toLocationId'] = ApiClient.convertToType(data['toLocationId'], 'String');
            }
            if (data.hasOwnProperty('vehicleTypeIds')) {
                obj['vehicleTypeIds'] = ApiClient.convertToType(data['vehicleTypeIds'], ['String']);
            }
            if (data.hasOwnProperty('fixedVehicleId')) {
                obj['fixedVehicleId'] = ApiClient.convertToType(data['fixedVehicleId'], 'String');
            }
            if (data.hasOwnProperty('minPickupTimeInt')) {
                obj['minPickupTimeInt'] = ApiClient.convertToType(data['minPickupTimeInt'], 'Number');
            }
            if (data.hasOwnProperty('minPickupTimeStr')) {
                obj['minPickupTimeStr'] = ApiClient.convertToType(data['minPickupTimeStr'], 'String');
            }
            if (data.hasOwnProperty('minPickupDayInt')) {
                obj['minPickupDayInt'] = ApiClient.convertToType(data['minPickupDayInt'], 'Number');
            }
            if (data.hasOwnProperty('maxPickupTimeInt')) {
                obj['maxPickupTimeInt'] = ApiClient.convertToType(data['maxPickupTimeInt'], 'Number');
            }
            if (data.hasOwnProperty('maxPickupTimeStr')) {
                obj['maxPickupTimeStr'] = ApiClient.convertToType(data['maxPickupTimeStr'], 'String');
            }
            if (data.hasOwnProperty('maxPickupDayInt')) {
                obj['maxPickupDayInt'] = ApiClient.convertToType(data['maxPickupDayInt'], 'Number');
            }
            if (data.hasOwnProperty('exactPickupTimeInt')) {
                obj['exactPickupTimeInt'] = ApiClient.convertToType(data['exactPickupTimeInt'], 'Number');
            }
            if (data.hasOwnProperty('exactPickupTimeStr')) {
                obj['exactPickupTimeStr'] = ApiClient.convertToType(data['exactPickupTimeStr'], 'String');
            }
            if (data.hasOwnProperty('exactPickupDayInt')) {
                obj['exactPickupDayInt'] = ApiClient.convertToType(data['exactPickupDayInt'], 'Number');
            }
            if (data.hasOwnProperty('minDeliveryTimeInt')) {
                obj['minDeliveryTimeInt'] = ApiClient.convertToType(data['minDeliveryTimeInt'], 'Number');
            }
            if (data.hasOwnProperty('minDeliveryTimeStr')) {
                obj['minDeliveryTimeStr'] = ApiClient.convertToType(data['minDeliveryTimeStr'], 'String');
            }
            if (data.hasOwnProperty('minDeliveryDayInt')) {
                obj['minDeliveryDayInt'] = ApiClient.convertToType(data['minDeliveryDayInt'], 'Number');
            }
            if (data.hasOwnProperty('maxDeliveryTimeInt')) {
                obj['maxDeliveryTimeInt'] = ApiClient.convertToType(data['maxDeliveryTimeInt'], 'Number');
            }
            if (data.hasOwnProperty('maxDeliveryTimeStr')) {
                obj['maxDeliveryTimeStr'] = ApiClient.convertToType(data['maxDeliveryTimeStr'], 'String');
            }
            if (data.hasOwnProperty('maxDeliveryDayInt')) {
                obj['maxDeliveryDayInt'] = ApiClient.convertToType(data['maxDeliveryDayInt'], 'Number');
            }
            if (data.hasOwnProperty('exactDeliveryTimeInt')) {
                obj['exactDeliveryTimeInt'] = ApiClient.convertToType(data['exactDeliveryTimeInt'], 'Number');
            }
            if (data.hasOwnProperty('exactDeliveryTimeStr')) {
                obj['exactDeliveryTimeStr'] = ApiClient.convertToType(data['exactDeliveryTimeStr'], 'String');
            }
            if (data.hasOwnProperty('exactDeliveryDayInt')) {
                obj['exactDeliveryDayInt'] = ApiClient.convertToType(data['exactDeliveryDayInt'], 'Number');
            }
            if (data.hasOwnProperty('demand')) {
                obj['demand'] = ApiClient.convertToType(data['demand'], 'Number');
            }
            if (data.hasOwnProperty('excessTravelTime')) {
                obj['excessTravelTime'] = ApiClient.convertToType(data['excessTravelTime'], 'Number');
            }
            if (data.hasOwnProperty('pickupServiceDuration')) {
                obj['pickupServiceDuration'] = ApiClient.convertToType(data['pickupServiceDuration'], 'Number');
            }
            if (data.hasOwnProperty('deliveryServiceDuration')) {
                obj['deliveryServiceDuration'] = ApiClient.convertToType(data['deliveryServiceDuration'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Trip</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Trip</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of Trip.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['tripId'] && !(typeof data['tripId'] === 'string' || data['tripId'] instanceof String)) {
            throw new Error("Expected the field `tripId` to be a primitive type in the JSON string but got " + data['tripId']);
        }
        // ensure the json data is a string
        if (data['tripName'] && !(typeof data['tripName'] === 'string' || data['tripName'] instanceof String)) {
            throw new Error("Expected the field `tripName` to be a primitive type in the JSON string but got " + data['tripName']);
        }
        // ensure the json data is a string
        if (data['fromLocationId'] && !(typeof data['fromLocationId'] === 'string' || data['fromLocationId'] instanceof String)) {
            throw new Error("Expected the field `fromLocationId` to be a primitive type in the JSON string but got " + data['fromLocationId']);
        }
        // ensure the json data is a string
        if (data['toLocationId'] && !(typeof data['toLocationId'] === 'string' || data['toLocationId'] instanceof String)) {
            throw new Error("Expected the field `toLocationId` to be a primitive type in the JSON string but got " + data['toLocationId']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['vehicleTypeIds'])) {
            throw new Error("Expected the field `vehicleTypeIds` to be an array in the JSON data but got " + data['vehicleTypeIds']);
        }
        // ensure the json data is a string
        if (data['fixedVehicleId'] && !(typeof data['fixedVehicleId'] === 'string' || data['fixedVehicleId'] instanceof String)) {
            throw new Error("Expected the field `fixedVehicleId` to be a primitive type in the JSON string but got " + data['fixedVehicleId']);
        }
        // ensure the json data is a string
        if (data['minPickupTimeStr'] && !(typeof data['minPickupTimeStr'] === 'string' || data['minPickupTimeStr'] instanceof String)) {
            throw new Error("Expected the field `minPickupTimeStr` to be a primitive type in the JSON string but got " + data['minPickupTimeStr']);
        }
        // ensure the json data is a string
        if (data['maxPickupTimeStr'] && !(typeof data['maxPickupTimeStr'] === 'string' || data['maxPickupTimeStr'] instanceof String)) {
            throw new Error("Expected the field `maxPickupTimeStr` to be a primitive type in the JSON string but got " + data['maxPickupTimeStr']);
        }
        // ensure the json data is a string
        if (data['exactPickupTimeStr'] && !(typeof data['exactPickupTimeStr'] === 'string' || data['exactPickupTimeStr'] instanceof String)) {
            throw new Error("Expected the field `exactPickupTimeStr` to be a primitive type in the JSON string but got " + data['exactPickupTimeStr']);
        }
        // ensure the json data is a string
        if (data['minDeliveryTimeStr'] && !(typeof data['minDeliveryTimeStr'] === 'string' || data['minDeliveryTimeStr'] instanceof String)) {
            throw new Error("Expected the field `minDeliveryTimeStr` to be a primitive type in the JSON string but got " + data['minDeliveryTimeStr']);
        }
        // ensure the json data is a string
        if (data['maxDeliveryTimeStr'] && !(typeof data['maxDeliveryTimeStr'] === 'string' || data['maxDeliveryTimeStr'] instanceof String)) {
            throw new Error("Expected the field `maxDeliveryTimeStr` to be a primitive type in the JSON string but got " + data['maxDeliveryTimeStr']);
        }
        // ensure the json data is a string
        if (data['exactDeliveryTimeStr'] && !(typeof data['exactDeliveryTimeStr'] === 'string' || data['exactDeliveryTimeStr'] instanceof String)) {
            throw new Error("Expected the field `exactDeliveryTimeStr` to be a primitive type in the JSON string but got " + data['exactDeliveryTimeStr']);
        }

        return true;
    }


}

Trip.RequiredProperties = ["tripId", "fromLocationId", "toLocationId"];

/**
 * A unique identifier for this trip.
 * @member {String} tripId
 */
Trip.prototype['tripId'] = undefined;

/**
 * A name for this trip (optional).
 * @member {String} tripName
 */
Trip.prototype['tripName'] = undefined;

/**
 * The locationId for the origin location of this trip. This locationId must exist in the Locations passed in ProblemData for this problem.
 * @member {String} fromLocationId
 */
Trip.prototype['fromLocationId'] = undefined;

/**
 * The locationId for the destination location of this trip. This locationId must exist in the Locations passed in ProblemData for this problem.
 * @member {String} toLocationId
 */
Trip.prototype['toLocationId'] = undefined;

/**
 * The vehicleTypeIds that can be used to service this trip. These vehicleTypeIds must exist in the VehicleTypes passed in ProblemData for this problem.
 * @member {Array.<String>} vehicleTypeIds
 */
Trip.prototype['vehicleTypeIds'] = undefined;

/**
 * Optional. Pin this trip to a specific vehicle: the solve must use this vehicle for both the pickup and the delivery. The vehicleId must exist in the Vehicles passed in ProblemData. If the pin cannot be satisfied - the vehicle does not exist, or its type is excluded by this trip's vehicleTypeIds - the trip is returned unassigned rather than served by a different vehicle. Leave null for no pin.
 * @member {String} fixedVehicleId
 */
Trip.prototype['fixedVehicleId'] = undefined;

/**
 * An integer value representing the earliest time this trip can be picked up (time t=0 is the earliest start time). Leave empty if there are no time restrictions on pickup.
 * @member {Number} minPickupTimeInt
 */
Trip.prototype['minPickupTimeInt'] = undefined;

/**
 * A string value representing the earliest time this trip can be picked up. Leave empty if there are no time restrictions on pickup. The time format should correspond to the timeFormat field in ProblemData.timeSettings.
 * @member {String} minPickupTimeStr
 */
Trip.prototype['minPickupTimeStr'] = undefined;

/**
 * An integer value representing the earliest day this trip can be picked up. Only relevant if ProblemData.timeSettings.multipleDays is true and ProblemData.timeSettings.timeUnit is \"clock\". Leave empty if there are no restrictions on pickup.
 * @member {Number} minPickupDayInt
 */
Trip.prototype['minPickupDayInt'] = undefined;

/**
 * An integer value representing the latest time this trip can be picked up (time t=0 is the earliest start time). Leave empty if there are no time restrictions on pickup.
 * @member {Number} maxPickupTimeInt
 */
Trip.prototype['maxPickupTimeInt'] = undefined;

/**
 * A string value representing the latest time this trip can be picked up. Leave empty if there are no time restrictions on pickup. The time format should correspond to the timeFormat field in ProblemData.timeSettings.
 * @member {String} maxPickupTimeStr
 */
Trip.prototype['maxPickupTimeStr'] = undefined;

/**
 * An integer value representing the latest day this trip can be picked up. Only relevant if ProblemData.timeSettings.multipleDays is true and ProblemData.timeSettings.timeUnit is \"clock\". Leave empty if there are no restrictions on pickup.
 * @member {Number} maxPickupDayInt
 */
Trip.prototype['maxPickupDayInt'] = undefined;

/**
 * An integer value representing the exact time this trip must be picked up (time t=0 is the earliest start time). Leave empty if there are no time restrictions on pickup.
 * @member {Number} exactPickupTimeInt
 */
Trip.prototype['exactPickupTimeInt'] = undefined;

/**
 * A string value representing the exact time this trip must be picked up. Leave empty if there are no time restrictions on pickup. The time format should correspond to the timeFormat field in ProblemData.timeSettings.
 * @member {String} exactPickupTimeStr
 */
Trip.prototype['exactPickupTimeStr'] = undefined;

/**
 * An integer value representing the exact day this trip must be picked up. Only relevant if ProblemData.timeSettings.multipleDays is true and ProblemData.timeSettings.timeUnit is \"clock\". Leave empty if there are no restrictions on pickup.
 * @member {Number} exactPickupDayInt
 */
Trip.prototype['exactPickupDayInt'] = undefined;

/**
 * An integer value representing the earliest time this trip can be delivered (time t=0 is the earliest start time). Leave empty if there are no time restrictions on delivery.
 * @member {Number} minDeliveryTimeInt
 */
Trip.prototype['minDeliveryTimeInt'] = undefined;

/**
 * A string value representing the earliest time this trip can be delivered. Leave empty if there are no time restrictions on delivery. The time format should correspond to the timeFormat field in ProblemData.timeSettings.
 * @member {String} minDeliveryTimeStr
 */
Trip.prototype['minDeliveryTimeStr'] = undefined;

/**
 * An integer value representing the earliest day this trip can be delivered. Only relevant if ProblemData.timeSettings.multipleDays is true and ProblemData.timeSettings.timeUnit is \"clock\". Leave empty if there are no restrictions on delivery.
 * @member {Number} minDeliveryDayInt
 */
Trip.prototype['minDeliveryDayInt'] = undefined;

/**
 * An integer value representing the latest time this trip can be delivered (time t=0 is the earliest start time). Leave empty if there are no time restrictions on delivery.
 * @member {Number} maxDeliveryTimeInt
 */
Trip.prototype['maxDeliveryTimeInt'] = undefined;

/**
 * A string value representing the latest time this trip can be delivered. Leave empty if there are no time restrictions on delivery. The time format should correspond to the timeFormat field in ProblemData.timeSettings.
 * @member {String} maxDeliveryTimeStr
 */
Trip.prototype['maxDeliveryTimeStr'] = undefined;

/**
 * An integer value representing the latest day this trip can be delivered. Only relevant if ProblemData.timeSettings.multipleDays is true and ProblemData.timeSettings.timeUnit is \"clock\". Leave empty if there are no restrictions on delivery.
 * @member {Number} maxDeliveryDayInt
 */
Trip.prototype['maxDeliveryDayInt'] = undefined;

/**
 * An integer value representing the exact time this trip must be delivered (time t=0 is the earliest start time). Leave empty if there are no time restrictions on delivery.
 * @member {Number} exactDeliveryTimeInt
 */
Trip.prototype['exactDeliveryTimeInt'] = undefined;

/**
 * A string value representing the exact time this trip must be delivered. Leave empty if there are no time restrictions on delivery. The time format should correspond to the timeFormat field in ProblemData.timeSettings.
 * @member {String} exactDeliveryTimeStr
 */
Trip.prototype['exactDeliveryTimeStr'] = undefined;

/**
 * An integer value representing the exact day this trip must be delivered. Only relevant if ProblemData.timeSettings.multipleDays is true and ProblemData.timeSettings.timeUnit is \"clock\". Leave empty if there are no restrictions on delivery.
 * @member {Number} exactDeliveryDayInt
 */
Trip.prototype['exactDeliveryDayInt'] = undefined;

/**
 * The amount of vehicle capacity this trip consumes.
 * @member {Number} demand
 * @default 1
 */
Trip.prototype['demand'] = 1;

/**
 * Maximum minutes the actual pickup->delivery transit may exceed the direct travel time for this trip (caps detours from pooling). Null = no cap.
 * @member {Number} excessTravelTime
 */
Trip.prototype['excessTravelTime'] = undefined;

/**
 * Minutes to service the pickup (e.g. park and load) at the trip's origin. Charged at the pickup stop. Defaults to 0.
 * @member {Number} pickupServiceDuration
 * @default 0
 */
Trip.prototype['pickupServiceDuration'] = 0;

/**
 * Minutes to service the drop-off (e.g. park and unload) at the trip's destination. Charged at the delivery stop. Defaults to 0.
 * @member {Number} deliveryServiceDuration
 * @default 0
 */
Trip.prototype['deliveryServiceDuration'] = 0;






export default Trip;

